// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"20":"sandbox","243":"lesson","631":"lessonintro","796":"coursedashboard","960":"changepassword"}[chunkId] + "." + {"20":"d1fbcd98","243":"2e3937a2","631":"342a7b3d","796":"44c79f23","960":"7f12b307"}[chunkId] + ".css";
};